<template>
  
</template>

<script>
export default {
    name: 'tcprject',
    mounted(){
    let id=533100
    if (this._isMobile()) {
      this.$router.replace(`/mobile?id=${id}`);
    } else {
      this.$router.replace(`/pc?id=${id}`);
    }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>

<style>

</style>